import React from "react";
import { bool } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
  faApple,
  faGooglePlay,
} from "@fortawesome/free-brands-svg-icons";

import { StyledMenu } from "./Menu.styled";
import {Link,useLocation} from 'react-router-dom'
import { Link  as Link1} from "react-scroll";
import { useHistory } from "react-router-dom";




const Menu = ({ open, setOpen }) => {
  const social_icon_style = {
    justifyContent: "space-between",
    width: "55%",
    display: "flex",
    margin: " 0 auto",
  };
  const history = useHistory();

  const goToFromMobile=(link)=>{
    setOpen(!open)    
    console.log(link)
    history.push(link)
 
  }
const location = useLocation();

let navItems=[{
  ar:'الرئيسية' ,
 en:'Home',
 to:'Home'
 
},{
   ar:'الخصائص' ,
 en:'Features',
 to:'Features'
},{
  ar:'الشركات' ,
en:'Company Website',
to:'Company'
},{
  ar:'السياسه و الخصوصيه' ,
en:'Privacy&Policy',
topr:'/privacy',
toprAr:'/privacy_ar'

},{
  ar:'تواصل معنا' ,
en:'Contact',
to:'Contact'
},{
  ar:'الانجليزيه' ,
en:'العربيه',
to:''
}]


  return (
    <StyledMenu open={open }>
  

{navItems.map((value, index) => {
  if(location.pathname=='/ar'){
  if (index!==(navItems.length-1)){
    if(value.topr !==undefined){
      return <Link to={value.toprAr}  onClick={() => setOpen(!open)}  key={index} className='fontarabic'>{value.ar}  </Link>

    }
    else{
      return <Link1 to={value.to} spy={true} smooth={true} offset={50} duration={500} onClick={() => setOpen(!open)}  key={index} className='fontarabic'>{value.ar}  </Link1>

    }
  }else{
    
    return <Link to='/' spy={true} smooth={true} offset={50} duration={500} onClick={() => setOpen(!open)}  key={index} className='fontarabic'>{value.ar}  </Link>
 
  }
  }
  else if(location.pathname=='/'){
    if (index!==(navItems.length-1)){
      if(value.topr !==undefined){

        return <Link to={value.topr}  onClick={() => setOpen(!open)}  key={index}>{value.en}  </Link>

      }
      else{
        return <Link1 to={value.to} spy={true} smooth={true} offset={50} duration={500} onClick={() => setOpen(!open)}  key={index}>{value.en}  </Link1>

      }

    }else {
      return <Link to='/ar' spy={true} smooth={true} offset={50} duration={500} onClick={() => setOpen(!open)}  key={index} className='fontarabic'>{value.en}  </Link>
   
    }
  }
  if(location.pathname=='/privacy'){
    if (index!==(navItems.length-1)){
      if(value.topr !==undefined){

        return <Link  onClick={() => setOpen(!open)}  key={index}>{value.en}  </Link>

      }
      else{
        return <a   onClick={() => goToFromMobile(`/#${value.to}`)}  key={index} className='fontarabic'>{value.en}  </a>

      }
  
    
    }else{
      
      return <Link to='/ar' spy={true} smooth={true} offset={50} duration={500} onClick={() => setOpen(!open)}  key={index} className='fontarabic'>{value.en}  </Link>
   
    }
    }
    else if(location.pathname=='/privacy_ar'){
      if (index!==(navItems.length-1)){
        if(value.topr !==undefined){

          return <Link  onClick={() => setOpen(!open)}  key={index}>{value.ar}  </Link>
  
        }
        else{
        return <a   onClick={(e) => goToFromMobile(`/ar#${value.to}`)}  key={index} className='fontarabic'>{value.ar}  </a>
  
        }
  
      }else {
        return <Link to='/' spy={true} smooth={true} offset={50} duration={500} onClick={() => setOpen(!open)}  key={index} className='fontarabic'>{value.ar}  </Link>
     
      }
    }

  
})}

                  

      
        <div className="social_icons" style={social_icon_style}>
        <a href='https://www.instagram.com/noswazeefa/' target="_blank">  <FontAwesomeIcon icon={faInstagram} /></a>
        <a href='https://www.facebook.com/noswazeefasa/' target="_blank">  <FontAwesomeIcon icon={faFacebookF} /></a>
        <a href='https://www.linkedin.com/company/noswazeefa/?viewAsMember=true' target="_blank">   <FontAwesomeIcon icon={faLinkedinIn} /></a>
        </div>

    </StyledMenu>
  );
};
Menu.propTypes = {
  open: bool.isRequired,
};
export default Menu;
